export enum ApplicationStatus {
    DECLINED = 'Declined',
    DRAFT = 'Draft',
    SUBMITTED = 'Submitted',
    APPROVED = 'Approved',
    CANCELED = 'Canceled'
}
